export const logger = ([...args]) => {
  console.log(`TIMESTAMP: ${new Date().toISOString()}`, ...args);
};
